import { ArrowRight, Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF } from "./content";

export const Hero = () => (
  <section
    id="top"
    className="relative min-h-[620px] overflow-hidden bg-white md:min-h-[680px]"
    data-testid="hero-section"
  >
    <img
      src="/assets/dellsjo-hero-office.jpg"
      alt="Ljus och modern kontorsmiljö"
      className="absolute inset-0 h-full w-full object-cover object-center"
      data-testid="hero-image"
    />

    <div
      className="absolute inset-0 bg-[linear-gradient(90deg,#ffffff_0%,#ffffff_23%,rgba(255,255,255,0.98)_31%,rgba(255,255,255,0.82)_43%,rgba(255,255,255,0.38)_57%,rgba(255,255,255,0.08)_72%,rgba(255,255,255,0)_84%)]"
      aria-hidden
    />
    <div
      className="absolute inset-0 bg-[linear-gradient(90deg,rgba(255,255,255,0.96)_0%,rgba(255,255,255,0.88)_58%,rgba(255,255,255,0.38)_100%)] md:hidden"
      aria-hidden
    />

    <div className="relative z-10 mx-auto flex min-h-[620px] max-w-[1480px] items-center px-5 py-12 sm:px-8 md:min-h-[680px] lg:px-12 xl:px-16">
      <div className="max-w-[39rem]">
        <p className="eyebrow">Städ- & trädgårdsservice · Södertälje</p>
        <h1
          className="mt-4 text-[2.6rem] font-normal leading-[1.04] tracking-[-0.035em] text-[var(--ink)] sm:text-[3.65rem] lg:text-[4rem]"
          style={{ fontFamily: 'Georgia, "Times New Roman", serif' }}
          data-testid="hero-heading"
        >
          Professionell städning för företag och fastigheter
        </h1>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-[var(--ink-soft)] sm:text-lg">
          Personlig städservice för företag, BRF:er och fastighetsägare i Södertälje,
          Trosa, Mariefred, Nykvarn och Järna samt i Sörmland.
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <a href="#offert" className="btn btn-red" data-testid="hero-quote-button">
            Begär offert <ArrowRight size={18} aria-hidden />
          </a>
          <a href={PHONE_HREF} className="btn btn-outline" data-testid="hero-call-button">
            <Phone size={18} aria-hidden /> {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </div>
  </section>
);
